import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import "./styles.css";

const viewSize = 5;
const cubeSize = 1.07;
const wireframeColor = 0xa8a8a8;
const grid = false;
const modelSize = 0.0027;

const sphereSize = 0.23;
const sphereColor = 0xffffff;
const sceneBackground = 0xa8a8a8;

var scene = new THREE.Scene();
var aspectRatio = window.innerWidth / window.innerHeight;
const camera = new THREE.OrthographicCamera(
  (-aspectRatio * viewSize) / 2,
  (aspectRatio * viewSize) / 2,
  viewSize / 2,
  -viewSize / 2,
  -1000,
  10000
);
// camera.position.x = 8.7;
// camera.position.y = 4;
// camera.position.z = 0.1;
camera.position.x = 10;
camera.position.y = 4;
camera.position.z = -8;
camera.lookAt(0, 0, 0);
scene.add(camera);

var renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);

document.body.appendChild(renderer.domElement);
scene.background = new THREE.Color(sceneBackground);

///////////////////////////////////////////////////////////////
//// 8 Spheres
const group = new THREE.Group();
const sphereGeo = new THREE.SphereGeometry(sphereSize, 30, 30);
const sphereMat = new THREE.MeshBasicMaterial({ color: sphereColor });
const wireframeMat = new THREE.MeshBasicMaterial({ color: wireframeColor });
const sphere1 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere2 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere3 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere4 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere5 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere6 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere7 = new THREE.Mesh(sphereGeo, sphereMat);
const sphere8 = new THREE.Mesh(sphereGeo, sphereMat);

sphere1.position.x = -cubeSize / 2;
sphere1.position.y = cubeSize / 2;
sphere1.position.z = cubeSize / 2;

sphere2.position.x = -cubeSize / 2;
sphere2.position.y = -cubeSize / 2;
sphere2.position.z = cubeSize / 2;

sphere3.position.x = -cubeSize / 2;
sphere3.position.y = -cubeSize / 2;
sphere3.position.z = -cubeSize / 2;

sphere4.position.x = cubeSize / 2;
sphere4.position.y = -cubeSize / 2;
sphere4.position.z = -cubeSize / 2;

sphere5.position.x = cubeSize / 2;
sphere5.position.y = cubeSize / 2;
sphere5.position.z = -cubeSize / 2;

sphere6.position.x = cubeSize / 2;
sphere6.position.y = cubeSize / 2;
sphere6.position.z = cubeSize / 2;

sphere7.position.x = -cubeSize / 2;
sphere7.position.y = cubeSize / 2;
sphere7.position.z = -cubeSize / 2;

sphere8.position.x = cubeSize / 2;
sphere8.position.y = -cubeSize / 2;
sphere8.position.z = cubeSize / 2;

group.add(
  sphere1,
  sphere2,
  sphere3,
  sphere4,
  sphere5,
  sphere6,
  sphere7,
  sphere8
);

////////////////////////////////////////////////////////////////
// Instantiate a loader for the model
const loader = new GLTFLoader();
// Load a glTF resource
loader.load(
  "https://minmlgroup.s3.amazonaws.com/minml.glb",
  function (gltf) {
    const model = gltf.scene;
    // model.rotation.y += 1;
    model.scale.set(modelSize, modelSize, modelSize);
    model.traverse(function (child) {
      if (child.isMesh) {
        child.material = wireframeMat;
        //sets wireframe always top
        child.material.depthTest = false;
        child.material.renderOrder = 10;
      }
    });
    scene.add(model);
  },
  function (xhr) {
    console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
  },
  function (error) {
    console.log("An error happened");
  }
);

//// Group wireframe and Spheres
// const logo = new THREE.Group();
// logo.add(group, loader);
scene.add(group);

//// Adding orbitControls
const controls = new OrbitControls(camera, renderer.domElement);
controls.autoRotate = true;

if (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
) {
  // true for mobile device
  controls.autoRotateSpeed = 10;
} else {
  // false for not mobile device
  controls.autoRotateSpeed = 3;
}

controls.rotateSpeed = 1;
controls.enableZoom = false;
controls.enableDamping = true;
controls.dampingFactor = 0.12;
if (grid) {
  const grid = new THREE.GridHelper(20, 20);
  scene.add(grid);
  scene.add(new THREE.AxesHelper(20));
}

window.addEventListener("resize", onWindowResize, false);

function onWindowResize() {
  var aspect = window.innerWidth / window.innerHeight;

  camera.left = (viewSize * aspect) / -2;
  camera.right = (viewSize * aspect) / 2;
  camera.top = viewSize / 2;
  camera.bottom = -viewSize / 2;

  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}
///////////////////////////////////////////////////////////////

function render() {
  requestAnimationFrame(render);
  // logo.rotation.y += 0.001;
  renderer.render(scene, camera);

  controls.update();
}
render();
